import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
  text-align: center;
  font-family: 'Ubuntu', sans-serif;
`;

export const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

export const ErrorTitle = styled.h2`
  color: #dc2626;
  font-size: 1.8rem;
  margin-bottom: 1rem;
`;

export const ErrorMessage = styled.p`
  color: #4a5568;
  margin-bottom: 1.5rem;
  max-width: 500px;
`;

export const ErrorDetails = styled.div`
  background: #f1f5f9;
  padding: 1rem;
  border-radius: 8px;
  margin: 1rem 0;
  text-align: left;
  max-width: 100%;
  overflow-x: auto;
  
  pre {
    font-size: 0.8rem;
    color: #ef4444;
    margin-top: 0.5rem;
  }
`;

export const ErrorButton = styled.button`
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(59, 130, 246, 0.4);
  }
`;